export default __webpack_public_path__ + "static/media/Licenses_IMG-QA-04.6fb488be.png";